import {
  type CompanyId,
  isDefined,
  isNotDefined,
  LOCKABLE_TEAM_FIELDS,
  type LockableTeamField,
  type TeamId,
  type TeamUpdateData,
} from '@terros/common'
import { type LockedFields } from '../user'
import { usePreference } from '../preferences'
import { usePermissionCheck } from '../permissions'

export function useLockedTeamFields(targetId: TeamId | CompanyId | undefined): LockedFields<LockableTeamField> {
  const { data: canManage, error: permissionError } = usePermissionCheck({
    permissionType: 'user:manage',
    targetId,
  })
  const { data: lockedFields, error: preferenceError } = usePreference('lockedTeamFields')
  if (isNotDefined(targetId)) return { lockedFields: [], isLoading: false }
  const hasError = isDefined(permissionError) || isDefined(preferenceError)
  if (hasError || isNotDefined(canManage) || isNotDefined(lockedFields)) {
    return { lockedFields: [...LOCKABLE_TEAM_FIELDS], isLoading: true }
  }
  if (canManage) return { lockedFields: [], isLoading: false }
  return { lockedFields, isLoading: false }
}

export function omitLockedTeamFields(team: TeamUpdateData, lockedFields: LockableTeamField[]): TeamUpdateData {
  return lockedFields.reduce((rest, field) => ({ ...rest, [field]: undefined }), team)
}
